import * as ars from "./attachmentsReducerSupport";
import {
  attachedFileUploaded,
  attachedFileUploadedWithPath,
  moveFileToFile,
  setDocumentTypeInDirectory,
} from "./attachmentsReducerSupport";
import * as actionTypes from "store/actions/input/attachments/attachmentsActionTypes";
import * as persistenceActionTypes from "store/actions/persistence/persistenceActionTypes";

export const INIT_STATE = {
  attachedFiles: [],
  attachedFileNameOverrides: {},
  attachedFileDocumentTypes: {},
  attachedFilesHidden: {},
  subDirectories: [],
};

const attachmentsReducer = (state, action) => {
  if (state === undefined) {
    state = INIT_STATE;
  }
  const pld = action.payload;
  switch (action.type) {
    case persistenceActionTypes.LOAD_SUBMISSION_STARTED:
      return {
        ...INIT_STATE,
      };
    case persistenceActionTypes.LOAD_SUBMISSION_SUCCEEDED:
      return {
        ...INIT_STATE,
        ...action?.payload?.data?.state?.input?.attachments,
      };
    case actionTypes.CREATE_DIRECTORY:
      return ars.addDirectory(state, pld.parentId, pld.name);

    case actionTypes.REMOVE_DIRECTORY:
      return ars.removeDirectory(state, pld.directoryId);

    case actionTypes.ADD_FILE_TO_DIRECTORY:
      return ars.addFileToDirectory(state, pld.fileId, pld.directoryId);

    case actionTypes.REMOVE_FILE_FROM_DIRECTORY:
      return ars.removeFileFromDirectory(state, pld.fileId, pld.directoryId);

    case actionTypes.RENAME_DIRECTORY:
      return ars.renameDirectory(state, pld.directoryId, pld.name);

    case actionTypes.SET_NAME_OF_FILE_IN_DIRECTORY:
      return ars.setFileNameInDirectory(
        state,
        pld.fileId,
        pld.directoryId,
        pld.name
      );

    case actionTypes.MOVE_DIRECTORY_TO_DIRECTORY:
      return ars.moveDirectory(state, pld.dirId, pld.toDirId);

    case actionTypes.MOVE_FILE_TO_DIRECTORY:
      return ars.moveFileToDirectory(
        state,
        pld.fileId,
        pld.fromDirId,
        pld.toDirId,
        pld.embeddedFiles
      );

    case actionTypes.MOVE_FILE_TO_FILE:
      return moveFileToFile(
        state,
        pld.fileId,
        pld.fromDirId,
        pld.toDirId,
        pld.embeddedFiles
      );

    case actionTypes.ATTACHMENT_UPLOADED:
      return attachedFileUploaded(state, pld.fileId);

    case actionTypes.ATTACHMENT_UPLOADED_WITH_PATH:
      return attachedFileUploadedWithPath(state, pld.fileId, pld.relativePath);

    case actionTypes.SET_DOCUMENT_TYPE_OF_FILE_IN_DIRECTORY:
      return setDocumentTypeInDirectory(
        state,
        pld.fileId,
        pld.directoryId,
        pld.documentType
      );

    case actionTypes.CREATE_EMPTY_DIRECTORY_WITH_PATH: {
      const parts = pld.relativePath.split("/");
      const { state: updatedState } = ars.ensureDirectoriesExist(state, parts);
      return updatedState;
    }

    default:
      return state;
  }
};

export default attachmentsReducer;
